import React, { useState, useEffect, useCallback, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Box,
  Text,
  Select as SelectG,
  Calendar as CalendarG,
  Button,
} from 'grommet'
// import { useDarkMode } from '../../contextHook/darkMode'
import styled from 'styled-components'
import {
  setChoices,
  setInputModeStore,
  setDaysModeStore,
  setInputsStore,
} from '../../redux/rdg/actions'
import { usePersistValue } from '../../hook/usePersistValue'
import { Calendar, Trash, ClearOption } from 'grommet-icons'
import moment from 'moment'
import TextButton from '../Button/TextButton'
import { RelativeBox, AbsoluteBox } from '../Common'
import IconButton from '../Button/IconButton'
import { rgba, cssVar } from 'polished'
import { useClickOutsideRefs } from '../../hook/useClickOutsideRefs'
// import { useGeneralModal } from '../../contextHook/generalModal'
import CheckBoxGroup from '../Common/CheckBoxGroup'

const BoxG = styled(Box)`
  -webkit-tap-highlight-color: transparent;
`

const TotalInputsBox = styled(Box)`
  display: flex;
  @media (max-width: 335px) {
    display: none;
  }
`

const ScrollBox = styled(Box)`
  &::-webkit-scrollbar {
    width: 5px !important;
  }
  &::-webkit-scrollbar-track {
    background: ${props => props.theme.global.colors.scrollTrack} !important;
  }
  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme.global.colors.scrollThumb} !important;
    border-radius: 3px;
  }
`

const Select = styled(SelectG)`
  padding: 1.2rem 1rem;
`

const Input = ({ inputOptions }) => {
  // const toolColorsPersist = useSelector(
  //   state => state.settings.wheelColors.colors,
  // )
  // const [toolColors, setToolColors] = useState(['', '', '', ''])
  const choices = useSelector(state => state.rdg.choices)
  const inputMode = useSelector(state => state.rdg.inputMode) //add initialization for fullscreen purpose
  // const { value: darkMode } = useDarkMode()
  const { value: daysMode } = usePersistValue(state => state.rdg.daysMode, [])
  const { value: inputs } = usePersistValue(state => state.rdg.inputs, [])
  const dispatch = useDispatch()

  // useEffect(() => {
  //   setToolColors(toolColorsPersist)
  // }, [toolColorsPersist])

  const onChangeInput = option => {
    const inputIndex = option.value
    dispatch(setInputModeStore(inputIndex))
  }

  // const selectHoverColor =
  //   !darkMode || toolColors.length < 3 ? toolColors[0] : toolColors[2]

  // const { setConfirmModal } = useGeneralModal()

  const [editingMode, setEditingMode] = useState(false)
  const [showCalendar, setShowCalendar] = useState(false)
  const [selectedDatesDisplay, setSelectedDatesDisplay] = useState('')
  const [selectedDates, setSelectedDates] = useState(new Date().toISOString())
  const [tags, setTags] = useState([])
  const [format, setFormat] = useState('MMMM D, YYYY')
  const [inputFocused, setInputFocused] = useState([])
  // const [inputCount, setInputCount] = useState(0)

  const prevInputs = useRef(inputs)

  const ref = useRef([])
  useClickOutsideRefs(ref, () => handleCloseCalendar())

  const refTags = useRef([])

  useEffect(() => {
    if (showCalendar) {
      setEditingMode(false)
    }
  }, [showCalendar])

  useEffect(() => {
    setInputFocused(Array(inputs.length).fill(editingMode))
  }, [editingMode])

  useEffect(() => {
    let finalFormat = format
    if (inputMode === 3 || inputMode === 7) {
      // format: 'dddd, MMMM D, YYYY' || 'dddd, DD MMMM YYYY'
      finalFormat = finalFormat.substring(finalFormat.indexOf(',') + 2)
    }
    setSelectedDatesDisplay(getFormatDate(selectedDates, finalFormat))
  }, [selectedDates, format])

  useEffect(() => {
    const dateFormat = inputOptions.filter(
      input => input.value === inputMode,
    )[0].format
    setFormat(dateFormat)
    handleConvertTags(dateFormat)
  }, [inputMode])

  useEffect(() => {
    prevInputs.current = inputs
    if (inputs.length === 0) {
      setEditingMode(false)
    } else {
      setInputFocused(Array(inputs.length).fill(editingMode))
    }
    handleConvertTags(format)
  }, [inputs])

  useEffect(() => {
    const dateRanges = []
    inputs.map((item, index) => {
      const dateRange = item.split(',')
      if (dateRange.length === 1) {
        if (isDayOfWeek(dateRange, daysMode)) {
          if (
            !dateRanges.some(
              existingDateRange => existingDateRange[0] === dateRange[0],
            )
          ) {
            dateRanges.push(dateRange)
          }
        }
      } else if (dateRange.length === 2) {
        const [startDateStr, endDateStr] = dateRange
        const range = getDateRange(new Date(startDateStr), new Date(endDateStr))
        range.map((date, index2) => {
          if (isDayOfWeek(date, daysMode)) {
            if (
              !dateRanges.some(
                existingDateRange => existingDateRange[0] === date,
              )
            ) {
              dateRanges.push([date])
            }
          }
        })
      }
    })
    const formatedDates = getFormattedDates(dateRanges, format)
    // setInputCount(formatedDates.length)
    dispatch(setChoices(formatedDates))
  }, [format, daysMode, inputs])

  const handleConvertTags = dateFormat => {
    const dateRanges = []
    inputs.map((item, index) => {
      const dateRange = item.split(',')
      dateRanges.push(dateRange)
    })
    const formatedDate = getFormattedDates(dateRanges, dateFormat)
    setTags(formatedDate)
  }

  useEffect(() => {}, [inputFocused])

  const handleSelectCalendar = dates => {
    setSelectedDates(dates)
  }

  const handleCloseCalendar = () => {
    setShowCalendar(false)
  }

  const handleResetCalendar = () => {
    setSelectedDates(new Date().toISOString())
  }

  const handleTagAdd = () => {
    if (Array.isArray(selectedDates)) {
      const [start, end] = selectedDates[0]
      const startDate = new Date(start).toLocaleDateString('en-CA') // format as YYYY-MM-DD
      const endDate = new Date(end).toLocaleDateString('en-CA')
      dispatch(setInputsStore([...inputs, `${startDate},${endDate}`]))
    } else {
      const selectedDate = new Date(selectedDates).toLocaleDateString('en-CA')
      dispatch(setInputsStore([...inputs, selectedDate]))
    }
    handleCloseCalendar()
  }

  const setInputFocusedAtIndex = (inputFocused, index, value) => {
    const newState = [...inputFocused] // create a copy of the array
    newState[index] = value // modify the value at the desired index
    setInputFocused(newState)
  }

  // this is to make date input delete or cancel
  const onInputBoxBlur = useCallback((inputFocused, index) => {
    setInputFocusedAtIndex(inputFocused, index, false)
  }, [])

  const onInputBoxFocus = useCallback((inputFocused, index) => {
    setShowCalendar(false)
    setInputFocusedAtIndex(inputFocused, index, true)
  }, [])

  const deleteInput = useCallback((refTags, inputs, index) => {
    const tag = refTags.current[index]
    if (tag) {
      tag.blur()
    }
    const newItems = [...inputs]
    newItems.splice(index, 1)
    dispatch(setInputsStore(newItems))
  }, [])

  const onMouseDown = useCallback(event => {
    event.preventDefault()
  }, [])

  return (
    <BoxG gap=".5rem">
      <Text>Date Format:</Text>
      <Box width="100%" align="stretch" gap="1rem">
        <Select
          value={inputMode}
          valueKey={{ key: 'value', reduce: true }}
          onChange={onChangeInput}
          options={inputOptions}
          labelKey="name"
          plain
          dropProps={{ background: 'baseBackground' }}
          // children={option => {
          //   return (
          //     <Box
          //       direction="row"
          //       width="100%"
          //       justify="between"
          //       pad={{ horizontal: '1rem', vertical: '1.2rem' }}
          //       background={option.value === inputMode ? 'inputDarkLight' : ''}
          //     >
          //       <Text
          //         color={
          //           option.value === inputMode ? 'invertTextStrong' : 'text'
          //         }
          //         weight={500}
          //       >
          //         {option.name}
          //       </Text>
          //     </Box>
          //   )
          // }}
        />
      </Box>

      <Box
        direction="row"
        justify="between"
        align="center"
        margin={{ top: '.5rem' }}
      >
        <Box direction="row" align="baseline" gap=".7rem">
          <Text>Inputs:</Text>

          {choices.length > 0 && (
            <TotalInputsBox
              border={{
                color: 'border',
                size: '1px',
                style: 'solid',
                side: 'all',
              }}
              pad={{ horizontal: '3px', vertical: '2px' }}
              align="center"
              justify="center"
              round="3px"
            >
              <Text size="1.4rem">{choices.length}</Text>
            </TotalInputsBox>
          )}
        </Box>

        <Button
          ref={el => (ref.current[2] = el)}
          icon={<Calendar size="small" color="white" />}
          primary
          color="secondary"
          onClick={() => setShowCalendar(!showCalendar)}
          label="Choose Dates"
          style={{ padding: '.3rem 1rem', fontSize: '1.6rem' }}
          gap=".8rem"
        />
      </Box>

      <RelativeBox
        style={{ userSelect: 'none', width: '100%', marginBottom: '-.5rem' }}
      >
        {showCalendar && (
          <AbsoluteBox align="flex-end" right="0" top="0" style={{ zIndex: 1 }}>
            {(Array.isArray(selectedDates) || selectedDates) && (
              <Box
                round="medium"
                height="3rem"
                justify="center"
                border={{
                  color: 'secondary',
                  size: '3px',
                  style: 'solid',
                  side: 'all',
                }}
                background="baseBackground"
                pad={{ horizontal: '1.9rem' }}
                alignSelf="end"
              >
                <Text size="1.2rem">{selectedDatesDisplay}</Text>
              </Box>
            )}
            <Box
              ref={el => (ref.current[0] = el)}
              background="baseBackground"
              margin=".5rem"
              pad=".5rem"
              style={{ boxShadow: '0 0 5px var(--dropShadowColor)' }}
            >
              <CalendarG
                size="small"
                dates={selectedDates}
                range
                onSelect={handleSelectCalendar}
              />
              <Box
                pad={{ right: 'small' }}
                direction="row"
                justify="center"
                align="center"
                gap="small"
                margin={{ top: '.5rem' }}
              >
                <Button
                  style={{
                    width: '6rem',
                    height: '2.8rem',
                    fontSize: '1.4rem',
                    padding: '0',
                  }}
                  color="secondary"
                  label="Add"
                  primary
                  onClick={handleTagAdd}
                  disabled={!(Array.isArray(selectedDates) || selectedDates)}
                />
                <TextButton
                  weight="bold"
                  style={{ fontSize: '1.4rem', color: 'var(--text)' }}
                  onClick={() => handleResetCalendar()}
                  label="Reset"
                  underline
                />
              </Box>
            </Box>
          </AbsoluteBox>
        )}
      </RelativeBox>
      <RelativeBox
        height="197px"
        background="secondaryBg"
        ref={el => (ref.current[1] = el)}
        onClick={() => {
          if (editingMode) {
            setEditingMode(false)
          } else {
            setShowCalendar(!showCalendar)
          }
        }}
        style={{ userSelect: 'none' }}
      >
        {tags.length === 0 && (
          <Text
            style={{
              padding: '0.8rem 1rem',
              fontWeight: '500',
              color: 'var(--placeholder)',
            }}
          >
            Click here to pick a date or date range...
          </Text>
        )}
        <ScrollBox
          overflow="auto"
          direction="row"
          pad=".5rem"
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '.5rem',
            position: 'relative',
            userSelect: 'none',
          }}
        >
          {tags.map((tag, index) => (
            <RelativeBox
              ref={el => (refTags.current[index] = el)}
              id={`ItemInputBox${index}`}
              round="medium"
              height={{ min: '3rem' }}
              background="inputDarkLight"
              justify="center"
              pad={{ horizontal: '1.6rem' }}
              style={{ color: 'white', cursor: 'pointer' }}
              tabIndex={-1}
              onClick={e => e.stopPropagation()}
              onFocus={() => onInputBoxFocus(inputFocused, index)}
              onBlur={() => {
                if (!editingMode) {
                  onInputBoxBlur(inputFocused, index)
                }
              }}
            >
              <Text style={{ fontSize: '1.6rem' }} color="invertTextStrong">
                {tag}
              </Text>
              {inputFocused[index] && (
                <AbsoluteBox
                  round="medium"
                  width="100%"
                  height="100%"
                  top="0"
                  left="0"
                  align="center"
                  justify="center"
                  style={{
                    zIndex: 1,
                  }}
                  background={`${rgba(cssVar('--mid'), 0.6)}`}
                >
                  <IconButton
                    icon={<Trash size="small" color="reject" />}
                    onMouseDown={onMouseDown}
                    onClick={() => deleteInput(refTags, inputs, index)}
                  />
                </AbsoluteBox>
              )}
            </RelativeBox>
          ))}
        </ScrollBox>

        {inputs.length > 0 && (
          <AbsoluteBox
            style={{ zIndex: 2, borderRadius: '0 50% 0 0' }}
            pad={{ vertical: '3px', horizontal: '1px' }}
            bottom="0"
            left="0"
            background="secondaryBg"
          >
            <IconButton
              icon={<ClearOption size="20" color="reject" />}
              onClick={e => {
                e.stopPropagation()
                setShowCalendar(false)
                setEditingMode(!editingMode)
                // setInputFocused(Array(inputs.length).fill(!editingMode))
                // setConfirmModal({
                //   title: 'Remove All Inputs?',
                //   message:
                //     'All the current inputs will be removed. You cannot undo this action.',
                //   action: () => {
                //     dispatch(setInputsStore([]))
                //   },
                // })
              }}
            />
          </AbsoluteBox>
        )}
      </RelativeBox>

      <Text margin={{ top: '1.2rem' }}>Days of Week included:</Text>
      <CheckBoxGroup
        name="daysMode"
        options={[
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
          'Sunday',
        ]}
        value={daysMode}
        onChange={({ value, option }) => {
          dispatch(setDaysModeStore(value))
        }}
      />
    </BoxG>
  )
}

export default Input

const getDateRange = (startDate, endDate) => {
  const dates = []
  const currentDate = new Date(startDate)
  while (currentDate <= endDate) {
    const dateString = currentDate.toISOString().split('T')[0]
    dates.push(dateString)
    currentDate.setDate(currentDate.getDate() + 1)
  }
  return dates
}

const getDayName = dayIndex => {
  const daysOfWeek = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ]
  return daysOfWeek[dayIndex]
}

const isDayOfWeek = (dateString, daysMode) => {
  const date = new Date(dateString)
  const dayOfWeek = getDayName(date.getUTCDay())
  return daysMode.includes(dayOfWeek)
}

const getFormatDate = (date, dateFormat) => {
  if (Array.isArray(date)) {
    const [start, end] = date[0]
    const startDateString = moment(start).format(dateFormat)
    const endDateString = moment(end).format(dateFormat)
    return `${startDateString} - ${endDateString}`
  } else {
    return moment(date).format(dateFormat)
  }
}

const getFormattedDates = (dates, dateFormat) => {
  let formatedDate = []
  dates.map((item, index) => {
    let dateString = ''
    if (item.length === 1) {
      dateString = getFormatDate(item[0], dateFormat)
    } else {
      dateString = getFormatDate([item], dateFormat)
    }
    formatedDate = [...formatedDate, dateString]
  })
  return formatedDate
}
